
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './future-explanation';
const mainimage = '/Images/future1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "future" },
];

const Future = () => (
  <GrammarPageLayout
    level="A2"
    title="Future"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Future Exercises"
    seoDescription="Express future plans, predictions, and spontaneous decisions using 'will' and 'going to'. A2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default Future;

